@if (dataSignal().img && dataSignal().img !== null) {
<a class="flex cursor-pointer" tabindex="0" [routerLink]="[`/${pathNameSignal()}/detail`, dataSignal().id]">
  <figure>
    <img
      [src]="replaceBucket.replaceBucket(dataSignal().img)"
      [alt]="dataSignal().title || 'รูปภาพข่าวสาร'"
      [title]="dataSignal().title || 'รูปภาพข่าวสาร'"
      class="item-image"
      loading="lazy"
    />
    <figcaption>
      @switch (headingLevel) { @case ('h3') {
      <h3 class="font-size-22 font-weight-semibold line-clamp-2">{{ dataSignal().title }}</h3>
      } @default {
      <h2 class="font-size-22 font-weight-semibold line-clamp-2">{{ dataSignal().title }}</h2>
      } }
      <p class="font-size-16 font-weight-regular text-excerpt line-clamp-4">{{ dataSignal().excerpt }}</p>
    </figcaption>
  </figure>
</a>
} @else {
<div class="item-image"></div>
}
